import Vue from "vue";
import { MutationTree } from "vuex";
import { InvoiceSentConfirmationInformationAdminzoneState } from "@/types/store/adminzone";
import { InvoiceSentConfirmationData } from "@/types";

export const mutations: MutationTree<InvoiceSentConfirmationInformationAdminzoneState> = {
  SET_INVOICE_SENT_CONFIRMATION_DATA: (state, payload: Array<InvoiceSentConfirmationData>): Array<InvoiceSentConfirmationData> => Vue.set(state, 'invoiceConfirmationInformation', payload),
}
